import React from 'react';
import { Link } from 'react-router-dom';
import { IoIosArrowDown } from '@react-icons/all-files/io/IoIosArrowDown';
import { IoIosArrowUp } from '@react-icons/all-files/io/IoIosArrowUp';
import { DropdownColumnItem } from '../common/types';
interface MobileDropdownProps {
    label: string;
    leftColumn: {
        title?: string;
        items: DropdownColumnItem[];
    };
    rightColumn?: {
        title?: string;
        items: DropdownColumnItem[];
    };
    isOpen: boolean;
    toggleDropdown: () => void;
    closeMobileMenu: () => void;
    onPreload?: (to: string) => void;
}

const MobileDropdown: React.FC<MobileDropdownProps> = ({ label, leftColumn, rightColumn, isOpen, toggleDropdown, closeMobileMenu, onPreload }) => {
    const getItem = (item: DropdownColumnItem) => {
        if (typeof item === 'string') {
            return { label: item, to: `/${item.toLowerCase().replace(/\s+/g, '-')}`, visible: true };
        }
        return { label: item.label, to: item.to || item.href || '#', visible: item.visible !== false };
    };

    const renderItem = (item: DropdownColumnItem) => {
        const link = getItem(item);
        if (!link.visible) return null;
        return (
            <Link
                key={`${link.label}-${link.to}`}
                to={link.to}
                className="block hover:text-custom-blue"
                onClick={closeMobileMenu}
                onMouseEnter={() => onPreload?.(link.to)}
                onFocus={() => onPreload?.(link.to)}
                onTouchStart={() => onPreload?.(link.to)}
            >
                {link.label}
            </Link>
        );
    };

    return (
        <div className="inline-block text-left text-white font-bold font-inter w-full">
            {/* Button that toggles the dropdown's visibility on click */}
            <button
                onClick={toggleDropdown}
                className="w-full flex justify-between items-center px-4 py-2 text-white transition-colors duration-500"
                aria-expanded={isOpen}
            >
                {label} <span className="ml-2">{isOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}</span>
            </button>

            {/* Content that is toggled on click */}
            {isOpen && (
                <div className="bg-white text-gray-600 shadow-lg rounded-md border border-gray-200 p-3 flex flex-col w-full">
                    {/* Left column of the dropdown */}
                    <div className="p-4">
                        {leftColumn.title && (<div className="font-bold text-gray-400 mb-2">{leftColumn.title}</div>)}
                        {leftColumn.items.map(renderItem)}
                    </div>
                    {/* Right column of the dropdown */}
                    {rightColumn && (
                        <div className="p-4">
                            {rightColumn.title && (<div className="font-bold text-gray-400 mb-2">{rightColumn.title}</div>)}
                            {rightColumn.items.map(renderItem)}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default MobileDropdown;
